import qs from "qs";
import useSWR, { SWRConfiguration } from "swr";

import { useAPIRequest } from "./useAPIRequest";

export type QueryParams = Record<string, any>;

export const useAPI = <Data extends unknown>(
  path: string | null,
  query?: QueryParams,
  options?: SWRConfiguration
) => {
  const request = useAPIRequest();

  const url = path
    ? path + qs.stringify(query, { addQueryPrefix: true })
    : null;

  return useSWR<Data>(url, request, options);
};
